module.exports = __webpack_public_path__ + "static/media/ignacioZuniga.333f076f.jpg";